/**
 * React hook for roadmap-comment like state.
 *
 * Reactive read from SecureStorage — mirrors useCommentLike (the content
 * sibling) but reads the ROADMAP_COMMENT_LIKES key prefix with the
 * RoadmapCommentLikeStorage shape. Updates automatically when any component
 * toggles the like via likeRoadmapCommentUseCase (which writes the same key),
 * so the like button reflects the optimistic SecureStorage write without a
 * refetch.
 */

import { useListenToSecureStorageUpdates } from '@/data/storage/local/secureStorageWebCrypto';
import { SECURE_STORAGE_KEYS } from '@/domain/entities/secureStorage/secureStorageKeys';
import type { RoadmapCommentLikeStorage } from '@/domain/entities/secureStorage/secureStorageEntities';

export function useRoadmapCommentLike(commentId: string) {
  const storageKey = SECURE_STORAGE_KEYS.ROADMAP_COMMENT_LIKES + commentId;
  const { data, loading } = useListenToSecureStorageUpdates<RoadmapCommentLikeStorage>(storageKey);

  return {
    likeData: data,
    isLiked: data?.liked ?? false,
    loading,
  };
}
